import styled from 'styled-components'

export default styled.section`
  padding: 30px 0;
  box-sizing: border-box;

  .options {
    display: flex;
    flex-direction: column;
    gap: 8px;

    &:first-of-type {
      margin: 24px 0 0;
    }

    &-header {
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;

      .direction-container {
        display: flex;
        flex-direction: row;
        align-items: center;
        gap: 4px;

        span {
          font-weight: 700;
          font-size: 16px;
          color: ${ ({ theme }) => theme.colors.primary };
        }
      }
    }

    h3, .card {
      font-size: 16px;
    }

    .show-more-container {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 4px;
      
      img {
        width: 16px;
        height: 16px;
        filter: invert(26%) sepia(64%) saturate(2461%) hue-rotate(243deg) brightness(91%) contrast(101%);
      }
    }
  }

  .no-options {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    padding-top: 24px;
    gap: 16px;

    h3 {
      font-size: 22px;
    }

    h3, p {
      margin: 0;
    }

    img {
      margin-bottom: 20px;
    }

    button {
      margin-top: auto;
      width: 180px;
    }
  }

  @media screen and (max-width: 768px) {
    padding: 0;
    .options {
      h3, .card {
        margin: 10px 20px;
      }
    }

    .no-options {
      img {
        width: 90%;
      }
    }
  }
`
